var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDislike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "thumb_down_off_alt_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8936",
    "data-name": "Group 8936"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4470",
    "data-name": "Rectangle 4470",
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8938",
    "data-name": "Group 8938",
    transform: "translate(0.663 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8937",
    "data-name": "Group 8937"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10716",
    "data-name": "Path 10716",
    d: "M14.99,3H6A1.99,1.99,0,0,0,4.17,4.21L.91,11.82A3,3,0,0,0,3.66,16H9.31l-.95,4.58a1.508,1.508,0,0,0,.41,1.37,1.475,1.475,0,0,0,1.05.43,1.508,1.508,0,0,0,1.06-.44l5.53-5.54a2,2,0,0,0,.58-1.41V5A2.006,2.006,0,0,0,14.99,3ZM10.66,19.33l.61-2.92.5-2.41H3.66a.957.957,0,0,1-.83-.45.972.972,0,0,1-.08-.95L6,5h8.99v9.99Z",
    transform: "translate(-0.663 -3)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10717",
    "data-name": "Path 10717",
    d: "M21,3a2.006,2.006,0,0,0-2,2v8a2,2,0,0,0,4,0V5A2.006,2.006,0,0,0,21,3Z",
    transform: "translate(-0.663 -3)",
    fill: "#4d4d4d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.fab0f9852fda4f83e4c5b7376282b124.svg";
export { ForwardRef as ReactComponent };